export default function Spinner({style, label}){
    return <div><div id="loading" style={style}></div><span>{label}</span></div>;
}